import { GET_CONFIGS, GET_CONFIGS_SUCCESS, GET_CONFIGS_ERROR } from "./actionTypes"

export const getConfig = () => {
  return {
    type: GET_CONFIGS
  }
}

export const configSuccess = msg => {
  return {
    type: GET_CONFIGS_SUCCESS,
    payload: msg,
  }
}

export const configError = error => {
  return {
    type: GET_CONFIGS_ERROR,
    payload: error,
  }
}
